import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Home, ChevronRight, Users, Heart, Star, Music,
  ArrowUpRight, Mic2, Trophy, Globe, BookOpen, Handshake, Leaf
} from 'lucide-react';
import { fetchUKM } from '../utils/api';
import SEO from '../components/SEO';

const UKM_DATA = [
  {
    id: 'olahraga',
    category: 'Olahraga & Kesehatan',
    color: 'blue',
    ukm: [
      { name: 'UKM Basket STIKES HI', icon: <Trophy size={22} />, desc: 'Unit kegiatan olahraga basket yang aktif mengikuti kompetisi antar perguruan tinggi se-Provinsi Jambi.', members: 45, founded: 2008, achievements: 'Juara II Basket Putri Porseni Kesehatan Jambi 2023' },
      { name: 'UKM Badminton', icon: <Trophy size={22} />, desc: 'UKM badminton yang melatih dan mengembangkan bakat mahasiswa dalam olahraga bulutangkis.', members: 38, founded: 2010, achievements: 'Juara I Ganda Campuran Pertandingan Mahasiswa se-Jambi 2022' },
      { name: 'UKM Taekwondo HI', icon: <Trophy size={22} />, desc: 'Unit bela diri Taekwondo yang aktif dalam kompetisi daerah dan nasional.', members: 30, founded: 2015, achievements: 'Medali Emas Poomsae Putri PON Mahasiswa 2023' },
      { name: 'UKM Health Fitness', icon: <Heart size={22} />, desc: 'UKM kebugaran dan senam kesehatan untuk menjaga gaya hidup aktif dan sehat mahasiswa.', members: 60, founded: 2012, achievements: 'Komunitas sehat terfavorit pilihan mahasiswa 2023' },
    ],
  },
  {
    id: 'seni',
    category: 'Seni & Budaya',
    color: 'orange',
    ukm: [
      { name: 'UKM Paduan Suara & Musik', icon: <Music size={22} />, desc: 'Paduan suara dan band kampus yang tampil dalam acara wisuda, dies natalis, dan kompetisi seni.', members: 52, founded: 2005, achievements: 'Juara III Paduan Suara Festival Seni Mahasiswa Jambi 2023' },
      { name: 'UKM Tari Tradisional & Modern', icon: <Star size={22} />, desc: 'Melestarikan tari tradisional Melayu Jambi dan mengembangkan kreasi tari modern kontemporer.', members: 40, founded: 2007, achievements: 'Penampilan di Festival Budaya Jambi 2022 & 2023' },
      { name: 'UKM Teater & Seni Peran', icon: <Mic2 size={22} />, desc: 'UKM teater kreatif yang mengangkat tema kesehatan dan sosial dalam pentas drama dan pertunjukan.', members: 25, founded: 2014, achievements: 'Juara I Festival Teater Mahasiswa Kesehatan 2022' },
      { name: 'UKM Jurnalistik & Fotografi', icon: <Star size={22} />, desc: 'Mengembangkan bakat jurnalisme kampus, fotografi, dan konten kreator digital bidang kesehatan.', members: 35, founded: 2016, achievements: 'Pengelola Majalah Kampus "Sehat Bersama HI" sejak 2016' },
    ],
  },
  {
    id: 'keilmuan',
    category: 'Keilmuan & Profesi',
    color: 'purple',
    ukm: [
      { name: 'UKM Riset & Inovasi Kesehatan', icon: <BookOpen size={22} />, desc: 'Mendorong mahasiswa aktif dalam penelitian, penulisan jurnal, dan inovasi di bidang ilmu kesehatan.', members: 48, founded: 2011, achievements: 'Finalis PKM-Penelitian DIKTI 2023' },
      { name: 'UKM English Health Club', icon: <Globe size={22} />, desc: 'Mengembangkan kemampuan bahasa Inggris mahasiswa di bidang medis dan kesehatan untuk kesiapan global.', members: 55, founded: 2009, achievements: 'Delegasi konferensi kesehatan mahasiswa internasional 2023' },
      { name: 'UKM KSR (Korps Sukarela) PMI', icon: <Heart size={22} />, desc: 'Unit palang merah yang aktif dalam kegiatan donor darah, simulasi bencana, dan pertolongan pertama.', members: 65, founded: 2003, achievements: 'Penyelenggara Donor Darah Rutin 3x per tahun' },
      { name: 'UKM Kewirausahaan Muda', icon: <Star size={22} />, desc: 'Menumbuhkan jiwa wirausaha di bidang kesehatan, produk herbal, dan jasa layanan kesehatan mandiri.', members: 42, founded: 2018, achievements: 'Inkubasi 5 startup kesehatan mahasiswa sejak 2021' },
    ],
  },
  {
    id: 'keagamaan',
    category: 'Keagamaan & Sosial',
    color: 'green',
    ukm: [
      { name: 'UKM LLDIKTI Islam (LDK HI)', icon: <BookOpen size={22} />, desc: 'Lembaga dakwah kampus yang aktif dalam kajian keislaman, pengembangan karakter Islami, dan sosial keagamaan.', members: 80, founded: 2001, achievements: 'Penyelenggara PHBI dan Kajian Rutin Kampus' },
      { name: 'UKM Pramuka Kwarcab Kampus', icon: <Leaf size={22} />, desc: 'Gerakan pramuka yang membentuk karakter kepemimpinan, kemandirian, dan pengabdian masyarakat mahasiswa.', members: 55, founded: 2006, achievements: 'Juara II Perkemahan Pramuka Mahasiswa Jambi 2022' },
      { name: 'UKM Bakti Sosial Kesehatan', icon: <Handshake size={22} />, desc: 'Menggerakkan mahasiswa dalam pengabdian masyarakat: posyandu, penyuluhan kesehatan, dan bakti sosial.', members: 70, founded: 2008, achievements: 'Pelaksanaan Baksos Rutin ke 12 Kecamatan di Jambi' },
    ],
  },
];

const COLOR_MAP = {
  blue: { bg: 'bg-blue-50 dark:bg-blue-900/20', text: 'text-blue-600 dark:text-blue-400', border: 'border-blue-200 dark:border-blue-800/40', badge: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300' },
  orange: { bg: 'bg-orange-50 dark:bg-orange-900/20', text: 'text-orange-600 dark:text-orange-400', border: 'border-orange-200 dark:border-orange-800/40', badge: 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300' },
  purple: { bg: 'bg-purple-50 dark:bg-purple-900/20', text: 'text-[#7B2FBE] dark:text-purple-400', border: 'border-purple-200 dark:border-purple-800/40', badge: 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300' },
  green: { bg: 'bg-green-50 dark:bg-green-900/20', text: 'text-green-600 dark:text-green-400', border: 'border-green-200 dark:border-green-800/40', badge: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300' },
};

const ICON_MAP = { Trophy, Heart, Music, Star, Mic2, Globe, BookOpen, Handshake, Leaf };

const slugify = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const imageVariant = (src, width) => {
  const supported = src?.includes('/api/public/ukm-media/') || /\/ukm\/[a-f0-9-]{36}\.webp(?:\?|$)/i.test(src);
  return supported ? `${src}${src.includes('?') ? '&' : '?'}w=${width}` : src;
};

const normalizeUkmData = (categories) => categories.map((category) => ({
  id: category.slug,
  category: category.name,
  color: COLOR_MAP[category.color] ? category.color : 'purple',
  ukm: (category.items || []).map((item) => ({
    ...item,
    desc: item.description,
  })),
}));

const UkmIcon = ({ icon }) => {
  if (React.isValidElement(icon)) return icon;
  const Icon = ICON_MAP[icon] || Star;
  return <Icon size={22} />;
};

const UKM = () => {
  const { categorySlug } = useParams();
  const [ukmData, setUkmData] = useState(UKM_DATA);
  const activeCategory = categorySlug || 'semua';

  useEffect(() => {
    let active = true;
    fetchUKM()
      .then((data) => {
        if (active && Array.isArray(data)) setUkmData(normalizeUkmData(data));
      })
      .catch((error) => console.warn('Menggunakan template UKM lokal:', error.message));
    return () => { active = false; };
  }, []);

  const displayed = activeCategory === 'semua'
    ? ukmData
    : ukmData.filter(c => c.id === activeCategory);
  const selectedCategory = categorySlug ? ukmData.find((category) => category.id === categorySlug) : null;

  const totalUkm = ukmData.reduce((s, c) => s + c.ukm.length, 0);
  const totalMembers = ukmData.reduce((s, c) => s + c.ukm.reduce((a, u) => a + u.members, 0), 0);

  return (
    <div data-testid="ukm-page">
      <SEO
        title={selectedCategory ? `${selectedCategory.category} | UKM STIKES HI` : 'Unit Kegiatan Mahasiswa | STIKES HI'}
        description={selectedCategory
          ? `Jelajahi UKM bidang ${selectedCategory.category} di STIKES Harapan Ibu Jambi.`
          : 'Jelajahi seluruh Unit Kegiatan Mahasiswa STIKES Harapan Ibu Jambi.'}
      />
      <div className="page-hero pt-[70px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="flex items-center gap-2 text-white/70 text-sm mb-4 flex-wrap">
              <Link to="/" className="hover:text-white transition-colors flex items-center gap-1"><Home size={14} /> Beranda</Link>
              <ChevronRight size={14} />
              {selectedCategory ? <Link to="/ukm" className="hover:text-white">UKM</Link> : <span className="text-white">UKM</span>}
              {selectedCategory && <><ChevronRight size={14} /><span className="text-white">{selectedCategory.category}</span></>}
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white font-heading mb-4">
              {selectedCategory ? selectedCategory.category : 'Unit Kegiatan Mahasiswa'}
            </h1>
            <p className="text-white/80 max-w-xl text-base">
              {selectedCategory
                ? `Temukan komunitas, kegiatan, dan prestasi mahasiswa dalam bidang ${selectedCategory.category}.`
                : 'Bergabunglah dengan UKM STIKES HI Jambi untuk mengembangkan bakat, minat, dan kepribadian di luar kurikulum akademik.'}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="bg-[#F8F7FF] dark:bg-[#121020]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 mb-10">
            {[
              { val: totalUkm, label: 'Unit Kegiatan', icon: <Star size={18} /> },
              { val: totalMembers + '+', label: 'Anggota Aktif', icon: <Users size={18} /> },
              { val: ukmData.length, label: 'Bidang UKM', icon: <Trophy size={18} /> },
            ].map((s, i) => (
              <div key={i} className="bg-white dark:bg-[#1A182E] rounded-2xl p-5 text-center border border-gray-100 dark:border-gray-800 shadow-sm">
                <div className="w-10 h-10 rounded-xl bg-purple-50 dark:bg-purple-900/30 text-[#7B2FBE] flex items-center justify-center mx-auto mb-2">{s.icon}</div>
                <div className="text-2xl font-bold text-[#1A1A2E] dark:text-white font-heading">{s.val}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Filter */}
          <div className="flex gap-2 flex-wrap mb-8">
            <Link
              to="/ukm"
              data-testid="filter-semua"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                activeCategory === 'semua'
                  ? 'bg-[#7B2FBE] text-white shadow-lg shadow-purple-500/20'
                  : 'bg-white dark:bg-[#1A182E] text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700'
              }`}
            >
              Semua
            </Link>
            {ukmData.map(c => (
              <Link
                key={c.id}
                to={`/ukm/kategori/${c.id}`}
                data-testid={`filter-${c.id}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeCategory === c.id
                    ? 'bg-[#7B2FBE] text-white shadow-lg shadow-purple-500/20'
                    : 'bg-white dark:bg-[#1A182E] text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700'
                }`}
              >
                {c.category}
              </Link>
            ))}
          </div>

          {/* UKM Sections */}
          {!displayed.length && (
            <div className="mb-10 rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-14 text-center dark:border-gray-700 dark:bg-[#1A182E]">
              <h2 className="font-heading text-lg font-bold text-gray-900 dark:text-white">Kategori UKM tidak ditemukan</h2>
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">Alamat kategori mungkin sudah berubah atau belum tersedia.</p>
              <Link to="/ukm" className="mt-5 inline-flex rounded-xl bg-[#7B2FBE] px-5 py-2.5 text-sm font-semibold text-white">Lihat semua UKM</Link>
            </div>
          )}
          {displayed.map((cat) => {
            const c = COLOR_MAP[cat.color];
            return (
              <div key={cat.id} className="mb-12">
                <div className={`flex items-center gap-3 mb-5 px-4 py-3 rounded-xl ${c.bg} border ${c.border}`}>
                  <div className={`${c.text}`}><Star size={18} /></div>
                  <h2 className={`font-bold font-heading ${c.text}`}>{cat.category}</h2>
                  <span className={`ml-auto text-xs px-2 py-0.5 rounded-full ${c.badge}`}>{cat.ukm.length} UKM</span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {cat.ukm.map((u, i) => (
                    <motion.div
                      key={u.id || u.slug || i}
                      initial={{ opacity: 0, y: 16 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.06 }}
                      data-testid={`ukm-card-${cat.id}-${i}`}
                      className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl dark:border-gray-800 dark:bg-[#1A182E]"
                    >
                      <Link to={`/ukm/${u.slug || slugify(u.name)}`} className="group flex h-full flex-col">
                        <div className={`relative aspect-[16/10] overflow-hidden ${c.bg}`}>
                          {u.imageUrl ? (
                            <img
                              src={imageVariant(u.imageUrl, 480)}
                              alt={`Logo atau gambar ${u.name}`}
                              loading="lazy"
                              className={`h-full w-full transition duration-500 group-hover:scale-[1.035] ${u.imageFit === 'contain' ? 'object-contain p-5' : 'object-cover'}`}
                            />
                          ) : (
                            <div className={`grid h-full place-items-center ${c.text}`}><span className="grid h-20 w-20 place-items-center rounded-3xl bg-white/70 shadow-sm dark:bg-white/10"><UkmIcon icon={u.icon} /></span></div>
                          )}
                          <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[10px] font-semibold backdrop-blur ${c.badge}`}>{cat.category}</span>
                        </div>
                        <div className="flex flex-1 flex-col p-5">
                          <h4 className="mb-2 font-heading text-sm font-bold leading-tight text-[#1A1A2E] transition group-hover:text-[#7B2FBE] dark:text-white dark:group-hover:text-purple-300">{u.name}</h4>
                          <p className="mb-4 line-clamp-3 text-xs leading-relaxed text-gray-500 dark:text-gray-400">{u.desc}</p>
                          <div className="mt-auto space-y-2 border-t border-gray-100 pt-3 dark:border-gray-800">
                            <div className="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400"><Users size={12} className={c.text} /><span>{u.members} anggota aktif</span></div>
                            <div className="flex items-start gap-1.5 text-xs text-gray-500 dark:text-gray-400"><Star size={12} className={`mt-0.5 shrink-0 ${c.text}`} /><span className="line-clamp-2 leading-tight">{u.achievements}</span></div>
                            <span className={`inline-flex items-center gap-1 pt-1 text-xs font-semibold ${c.text}`}>Lihat profil UKM <ArrowUpRight size={13} /></span>
                          </div>
                        </div>
                      </Link>
                    </motion.div>
                  ))}
                </div>
              </div>
            );
          })}

          {/* CTA */}
          <div className="bg-gradient-to-br from-[#4C1D95] to-[#9333EA] rounded-2xl p-8 text-center text-white mt-4 mb-8">
            <h3 className="text-xl font-bold font-heading mb-2">Tertarik Bergabung?</h3>
            <p className="text-white/80 text-sm mb-5">Daftarkan diri Anda ke UKM pilihan pada awal semester. Hubungi pengurus UKM atau Bagian Kemahasiswaan untuk informasi lebih lanjut.</p>
            <Link
              to="/kontak"
              data-testid="join-ukm-btn"
              className="inline-flex items-center gap-2 bg-white text-[#7B2FBE] px-7 py-2.5 rounded-full font-semibold text-sm hover:bg-purple-50 transition-colors"
            >
              <Handshake size={16} /> Hubungi Kemahasiswaan
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UKM;
